export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8445.d53b58bf.jpg";